import { allKey } from 'app/constants'
import { ClusterParams } from 'app/plugins/infrastructure/components/common/model'
import store from 'app/store'
import { kaapiClustersSelector } from 'k8s/components/kaapi/clusters/selectors'
import { ensureArray, isNilOrEmpty } from 'utils/fp'

export default function parseClusterIdsFromParams<P extends ClusterParams>(params: P): string[] {
  const state = store.getState()
  const { clusterId } = params
  if (isNilOrEmpty(clusterId) || clusterId === allKey) {
    const allClusters: any[] = kaapiClustersSelector(state, params)
    return allClusters.map((cluster) => cluster.uuid)
  }
  return ensureArray(clusterId)
}
